module.exports = __webpack_public_path__ + "img/download.d512a921.png";